<template>
  <div class="contain">
    <div
      style="width: 100%;position: fixed;top: 0;z-index: 999;background: #fff;box-shadow: -6px 2px 17px 0px rgba(87,138,255,0.1);">
      <div class="logo" style="margin: 0 auto;background: #fff;">
        <div style="height: 70px;display: flex;align-items: center;padding: 0 80px;background: #fff;">
          <img src="../../assets/images/logo2.png" style="width: 144px;height: 40px;cursor: pointer;" @click="goHome">
        </div>
      </div>
    </div>
    <div style="height: 70px;"></div>
    <div class="newsBanner">
      <div class="newsBanner1">
        <div>
          <div
            style="font-size: 40px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1F2928;line-height: 56px;">
            日化标识码动态、资讯早知道</div>
          <div
            style="font-size: 18px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #808EA4;line-height: 25px;margin-top: 20px;">
            关注日化标识码最新动态，关注我们的每一次</div>
        </div>
        <div>
          <img src="../../assets/images/sc_0@2x.png" style="width: 327px;height: 210px;">
        </div>
      </div>
    </div>
    <div style="box-sizing: border-box;">
      <div class="tabList">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部文章" name="5"></el-tab-pane>
          <el-tab-pane label="营销干货" name="1"></el-tab-pane>
          <el-tab-pane label="企业动态" name="2"></el-tab-pane>
          <el-tab-pane label="使用指南" name="3"></el-tab-pane>
          <el-tab-pane label="客户案例" name="4"></el-tab-pane>
        </el-tabs>
        <div style="display: flex;justify-content: flex-start;flex-wrap: wrap">
          <div class="list" v-for="(item, index) in article" :key="index"
            style="box-shadow: 0px 2px 10px 0px rgba(220,221,236,0.5);border-radius: 8px;width: 396px;height: 320px;margin: 0 30px 30px;cursor: pointer;"
            @click="toDetails(item.id)">
            <img :src="baseURL + item.image" style="width: 395px;height: 200px;border-radius: 8px;">
            <div style="display: flex;align-items: center;padding: 12px;">
              <img src="../../assets/images/time.png" style="width: 16px;height: 16px;margin-right: 5px;">
              <span
                style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #767D8A;">{{item.publishTime}}</span>
            </div>
            <div
              style="padding: 12px;font-size: 17px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #36444D;">
              {{item.title}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getHotArticles,
    getIndex,
    getArticle,
    getLinks,
    getInfo,
    getMedia
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  export default {
    name: 'home',
    components: {

    },
    data() {
      return {
        activeName: '5',
        article: [],
        baseURL: '',
        media: [],
        linkList: [],
        info: {},
      }
    },
    methods: {
      goHome() {
        this.$router.push({
          path: '/',
        })
      },
      toDetails(id) {
        this.$router.push({
          path: '/newsDetails',
          query: {
            id
          }
        })
      },
      handleClick(tab, event) {
        console.log(tab, event);
        this.setArticle()
      },
      setArticle() {
        if (this.activeName == 5) {
          getArticle().then(res => {
            this.article = res.content
          })
        } else {
          getArticle({
            type: this.activeName
          }).then(res => {
            this.article = res.content
          })
        }

      },
      setMedia() {
        getMedia().then(res => {
          this.media = res
        })
      },
      setLinks() {
        getLinks().then(res => {
          this.linkList = res
        })
      },
      setInfo() {
        getInfo().then(res => {
          this.info = res
        })
      },
    },
    mounted() {
      this.baseURL = serverUrl.baseURL
      this.setArticle()
      this.setMedia()
      this.setInfo()
      this.setLinks()
    },
    created() {


    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media (max-width: 1500px) {

    .logo,
    .banner1,
    .xwzx,
    .banner2,
    .dataGrowth,
    .newsBanner1,
    .tabList {
      width: 1440px;
    }

    .bj1 {
      box-sizing: border-box;
      width: 1274px;
      height: 184px;
      margin: 0 auto;
      position: absolute;
      bottom: -92px;
      background: url(../../assets/images/bj_1.png) top center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hotArticlesTitle {
      width: 334px;
    }

    .hotArticlesContent {
      width: 334px;
    }


  }

  @media (min-width: 1500px) {

    .logo,
    .banner1,
    .xwzx,
    .banner2,
    .dataGrowth,
    .newsBanner1,
    .tabList {
      width: 1640px;
    }

    .bj1 {
      box-sizing: border-box;
      width: 1434px;
      height: 184px;
      margin: 0 auto;
      position: absolute;
      bottom: -92px;
      background: url(../../assets/images/bj_1@2x.png) top center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hotArticlesTitle {
      width: 388px;
    }

    .hotArticlesContent {
      width: 388px;
    }
  }

  ::-webkit-scrollbar {
    display: none !important;
    /* Chrome */
  }

  .contain {
    overflow-x: hidden;
    height: 100vh;
    position: relative;
  }

  .newsBanner {
    width: 100%;
    height: 219px;
    background: url(../../assets/images/newsBanner.png) top center no-repeat;
    background-size: cover;
  }

  .newsBanner1 {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 100px;
    box-sizing: border-box;
  }

  .tabList {
    margin: 0 auto;
    padding: 0 100px;
    box-sizing: border-box;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background: #fff;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #00C9AD;
  }

  /deep/ .is-active {
    font-weight: 500 !important;
    color: #00C9AD !important;
  }

  /deep/ .el-tabs__item {
    color: #8B9FA7;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding: 0 30px;
  }

  /deep/ .el-tabs__item:hover {
    color: #00C9AD;
  }

  .el-tabs {
    margin: 46px 0 36px;
  }

  a {
    color: #6C7480;
  }

  .erweima {
    display: none;
  }

  .weixin:hover .erweima {
    display: block !important;
  }

  .kf:hover {
    background: #F8FFFF;
    border-radius: 100px 100px 0px 0px;
  }

  .kf:hover .kfQr {
    display: block !important;
  }

  .list:hover {
    transition: all .25s ease-in;
    transform: translateY(-3px);
  }
</style>



// WEBPACK FOOTER //
// src/views/components/NewsList.vue